import * as React from "react";
import { useLocation } from "@grandvisionhq/frk-routing";
import CmsHeadTags from "../../../HeadTags/containers/HeadTags/HeadTags.js";
import { useBrPageContext } from "../../../../context/context/context.js";
import { getPageSeo } from "../../../../utils/utils/get-page-seo.js";
const CmsSeo = () => {
  const { query } = useLocation();
  const pageNum = Number(query.get("page") ?? 1);
  const page = useBrPageContext();
  const preview = page?.isPreview();
  const pageSeo = getPageSeo(page);
  if (!pageSeo && !preview) {
    return null;
  }
  return /* @__PURE__ */ React.createElement(React.Fragment, null, preview && /* @__PURE__ */ React.createElement("div", { style: { border: "2px solid black", padding: 10 } }, "SEO configuration"), pageSeo && /* @__PURE__ */ React.createElement(
    CmsHeadTags,
    {
      ...pageSeo,
      ogUrl: pageSeo.canonicalUrl,
      noFollow: pageSeo.nofollow,
      noIndex: pageSeo.noindex,
      ogImage: pageSeo.image?.url || "",
      pageNr: pageNum
    }
  ));
};
export {
  CmsSeo,
  CmsSeo as default
};
//# sourceMappingURL=Seo.js.map
